import { render, staticRenderFns } from "./model-icon.vue?vue&type=template&id=82d977fe&scoped=true"
import script from "./model-icon.vue?vue&type=script&lang=js"
export * from "./model-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d977fe",
  null
  
)

export default component.exports